














import Vue from 'vue';
import VePie from 'v-charts/lib/pie.common';
import 'echarts/lib/component/title';
import customerClient from '../../../apis';
import customerVuex from '../../../vuex/common';

export default Vue.extend({
  mixins: [customerVuex],
  components: {
    VePie,
  },
  data() {
    return {
      loading: true,
      legend: {
        bottom: 20,
        data: [
          {name: '最近3天', icon: 'circle'},
          {name: '最近7天', icon: 'circle'},
          {name: '最近1个月', icon: 'circle'},
          {name: '最近3个月', icon: 'circle'},
          {name: '其他', icon: 'circle'},
        ],
        itemWidth: 8,
      },
      chartSettings: {
        limitShowNum: 5,
        radius: 80,
        label: {
          formatter: '{d}%',
          textStyle: {
            color: '#000',
          },
        },
        hoverAnimation: false,
        itemStyle: {
          borderColor: '#fff',
          borderWidth: 2,
        },
      },
      title: {
        text: '互动用户占比',
        left: 'center',
        top: 50,
        textStyle: {
          color: '#000',
          fontSize: 14,
        },
      },
      tooltip: {
        show: false,
      },
      colors: ['#00A287', '#59CB74', '#F0B738', '#48A1FF', '#50E3C2'],
      chartData: {
        columns: ['type', 'count'],
        rows: [],
      },
    };
  },
  methods: {
    getInteractiveData() {
      customerClient.getInteractiveGroup(this.customerState.customerQuery).success((r) => {
        this.chartData.rows = [
          {type: '其他', count: r.more}, 
          {type: '最近3个月', count: r.threeMonth},
          {type: '最近1个月', count: r.oneMonth},
          {type: '最近7天', count: r.sevenDay},
          {type: '最近3天', count: r.threeDay},
        ];
        this.loading = false;
      }).error((e) => {
        this.$Message.error(e.toString());
      });
    },
  },
  mounted() {
    this.getInteractiveData();
  },
});
